/**
 * WordPress dependencies
 */
 import { __ } from '@wordpress/i18n';
 import { PluginSidebar, PluginSidebarMoreMenuItem } from '@wordpress/edit-post';
 import { registerPlugin } from '@wordpress/plugins';
 import { cog as icon } from '@wordpress/icons';
 import { PanelBody, Button, Spinner } from '@wordpress/components';
 import { useState } from '@wordpress/element';
 import apiFetch from '@wordpress/api-fetch';
 
 /**
  * Inner dependencies.
  */
 import './store/index.js';
 import TemplatesModel from './template-model';
 
 const Component = () => {
	 const [ { isTemplatesOpen, resetting }, setState ] = useState( {
		 isTemplatesOpen: false,
		 resetting:false
	 } );
	 const openModal = () =>
		 setState( {
			 isTemplatesOpen: true,
		 } );
	 const closeModal = () =>
		 setState( {
			 isTemplatesOpen: false,
		 } );
	 return (
		 <>
			 <PluginSidebarMoreMenuItem target="templazee-templates-library">
				 { __( 'Templazee Templates', '' ) }
			 </PluginSidebarMoreMenuItem>
			 <PluginSidebar
				 name="templazee-templates-library"
				 title={ __( 'Templazee Templates', '' ) }
				
			 >
				 <PanelBody>
					 <Button onClick={ () => openModal() } icon="admin-appearance" isSecondary>{ __( 'Browse Templates', '' ) }</Button>
					 { isTemplatesOpen && <TemplatesModel
						 onRequestClose={ () => closeModal() }
					 /> }
				 </PanelBody>
			 </PluginSidebar>
		 </>
	 );
 };
 
 registerPlugin( 'templazee-templates', {
	 render: Component,
 } );
 